module.exports = __webpack_public_path__ + "static/media/notification.3b77ae07.svg";